import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import cnb from "../../Assets/Projects/cnb.png";
import amrita from "../../Assets/Projects/amrita.png";
import accent from "../../Assets/Projects/accent.png";
import dsa from "../../Assets/Projects/dsa.png";
import cgpa from "../../Assets/Projects/cgpa.png";
import school from "../../Assets/Projects/school.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={school}
              isBlog={false}
              title="School Website"
              description="Designed and developed a modern, responsive website for my school as an alumni contribution. The site features dedicated sections for events, galleries, achievements, and infrastructure. It includes advanced scroll animations, horizontal galleries, launch countdown, and custom PHP-based gallery management. Technologies used include HTML, CSS, JavaScript."
              demoLink="https://savn.in"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={accent}
              isBlog={false}
              title="Accent Classifier"
              description="Developed a deep learning model for classifying major Indian Accents. Model is trained on a dataset of over 7000 1-minute audio samples. It was a challenging task for us to acquire the data required and process it using deep learning models. Our tasks involved processing the acquired audio files, creating spectrograms, converting them to images and feeding the data into CNN networks. We employed different techniques to combat overfitting. The model showcased promising results in detecting Hindi-accented speakers."
              ghLink="https://github.com/hspsuhas/Indian-Accent-Classifier"
              demoLink="https://indian-accent-classifier.streamlit.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={amrita}
              isBlog={false}
              title="Amrita Pay"
              description="Developed a campus payment system to provide seamless payment options for students. The system uses AWS Services such as SNS, Lambda, CloudFront, and DynamoDB for reliability, scalability, and cost-effective implementation. SNS ensures timely notifications for payment confirmations, while Lambda handles backend processing with minimal latency. CloudFront optimizes content delivery for fast and secure transactions, and DynamoDB provides a robust database solution to manage high volumes of transaction data efficiently."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cgpa}
              isBlog={false}
              title="CGPA Predictor"
              description="Developed a Web application that predicts a student's CGPA based on their current grade. This application is applicable to colleges where relative grading is practiced."
              ghLink="https://github.com/hspsuhas/CGPA-Predictor"
              demoLink="https://cgpa-predictor.github.io/main/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cnb}
              isBlog={false}
              title="Cows & Bulls"
              description="Cows and Bulls is a code-breaking game where players guess a secret 3-digit number within 10 attempts. Feedback includes cows for correct digits in wrong positions and bull for correct digits in correct positions. The responsive web interface, built with HTML, CSS, and JavaScript, features input fields, submission buttons, and a results table to track guesses and feedback. Enjoy cracking the code!"
              ghLink="https://github.com/hspsuhas/CowsAndBullsGame"
              demoLink="https://cowsandbulls.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dsa}
              isBlog={false}
              title="DSA Projects"
              description="This repository is a collection of hands-on projects related to Data Structures and Algorithms, showcasing key concepts, problem-solving skills, and implementation techniques in computer science. Project Highlights: Huffman Coding, Metro Planner, Stack-Based Calculator, Sudoku Solver, ToDo List"
              ghLink="https://github.com/hspsuhas/DSAProjects"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
